import React from "react";
import styles from "./Loading.module.scss";

interface Props {
  variant?: "default" | "inner" | "modal";
  message?: string;
}

const Loading: React.FC<Props> = ({ variant = "default", message }) => {
  const { centerContainer, full, modal } = styles;
  let className = "";
  if (variant === "default") {
    className = `${centerContainer} ${full}`;
  } else if (variant === "modal") {
    className = `${centerContainer} ${modal}`;
  }

  return (
    <div className={className} data-testid="loading">
      <div className={styles.ldsRing}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {message}
    </div>
  );
};

export default React.memo(Loading);
